import SelectGroup from './SelectGroup.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'SelectGroup', SelectGroup);
  },
};
